var ASDebugger = function (gState, klass = {}) {
    var debug = {};
    if (!window.console) return function() {};
    if (gState) {
        for (var m in console)
            if (typeof console[m] == 'function') {
                var prepend = 'AS Player :';
                prepend += (klass && klass.getClassName) ? ' ' + klass.getClassName() + ' :' : '';
                debug[m] = console[m].bind(window.console, prepend);
            }
    } else {
        for (var m in console)
            if (typeof console[m] == 'function')
                debug[m] = function() {};
    }
    return debug;
};

export default ASDebugger;


// WEBPACK FOOTER //
// ./src/utils/ASDebugger.js